import type { TOC } from '@ember/component/template-only';
import { concat } from '@ember/helper';
import { PrismModal } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import type MarketRevenueInsightIssueTableController from 'lumen/controllers/market/revenue-insight/issue-table';

interface MarketRevenueInsightIssueTableSignature {
  Args: {
    controller: MarketRevenueInsightIssueTableController;
    model: unknown;
  };
}

<template>
  <PrismModal
    @onClose={{@controller.multi.redirectOnClose}}
    @title={{t "revenue_insight.warning.hotels_with_incomplete data"}}
  >
    <div class="ri-modal modal--medium">
      <table class="default-table">
        <thead>
          <tr>
            <th>{{t "rates.hotelname"}}</th>
            <th>{{t "general.reason"}}</th>
          </tr>
        </thead>
        <tbody>
          {{#each @controller.hotelsWithIssues as |hotel|}}
            {{#each hotel.meta.issues as |issue|}}
              <tr>
                <td>{{hotel.displayValue}}</td>
                <td>
                  {{t (concat "revenue_insight.issue.explanation." issue)}}
                </td>
              </tr>
            {{/each}}
          {{/each}}
        </tbody>
      </table>
    </div>
  </PrismModal>
</template> satisfies TOC<MarketRevenueInsightIssueTableSignature>;
